import dashboard from "./dashboard.service";
import chat from "./chat.service";

export { dashboard, chat };

export default {
  dashboard,
  chat,
};
